/**
 * @generated SignedSource<<c783d1ae424fe9e58f9788adfc6fce5a>>
 * @relayHash 409380a00146ae3b415da19a5d574e54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 425ad325217bbd6c5c11424db1069eb65abcb4ffe5316659f0b3a3081c180ccb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SoftwareOnboardingPageGupsQuery } from './SoftwareOnboardingPageGupsQuery.graphql';

const node: PreloadableConcreteRequest<SoftwareOnboardingPageGupsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "425ad325217bbd6c5c11424db1069eb65abcb4ffe5316659f0b3a3081c180ccb",
    "metadata": {},
    "name": "SoftwareOnboardingPageGupsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
